/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Action, createReducer, on } from '@ngrx/store';
import { UserModel } from '../../models';
import { UsersUpdatedAction } from '../actions';

export interface UserState {
  dictionaryByFullName: { [fullName: string]: UserModel };
}

const initialState: UserState = {
  dictionaryByFullName: null,
};

const adapterReducer = createReducer(
  initialState,
  on(UsersUpdatedAction, (state, action) => {
    return {
      ...state,
      dictionaryByFullName: action.userDictionary,
    };
  }),
);

export const userReducer = (state = initialState, action: Action) => adapterReducer(state, action);
